import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

/** The pill every change-mark number shares: on the page, in the list of changes and in the rail. */
export const MARK_LABEL_VARIANT = LabelVariant.ORANGE;
